import { createApp } from 'vue';
import HomeIndex from './pages/HomeIndex.vue';

const pageData = window.pageData; // Zorg dat je dit injecteert vanuit Razor

createApp(HomeIndex, { data: pageData }).mount('#vue-home-index');

